import {Tile} from '../models/tile.model';
import {getAppSectionName} from '../models/reservation.model';

export class TileFactory {

  private static createTile(id: string, label: string, image: string, routerLink: string, testId: string): Tile {
    return {
      id,
      label,
      image,
      routerLink,
      testId,
    };
  }

  static createAbrirTile(image?: string): Tile {
    return this.createTile('abrir', 'Abrir', image || 'images/abrir.png', '/', 'home-open');
  }

  static createCheckInTile(image?: string): Tile {
    return this.createTile('checkin', 'Check-In', image || 'images/check-in.png', '/', 'home-check-in');
  }

  static createWelcomeTile(image?: string): Tile {
    return this.createTile('welcome', 'Bienvenido', image || 'images/bienvenido.png', '/welcome', 'home-welcome');
  }

  static createHowWorksTile(image?: string): Tile {
    return this.createTile('howto', 'Cómo funciona', image || 'images/como-funciona.png', '/how-it-works', 'home-howworks');
  }

  static createHouseRulesTile(image?: string): Tile {
    return this.createTile('normas', 'Normas', image || 'images/normas.png', '/house-rules', 'home-house-rules');
  }

  static createRecommendationsTile(image?: string): Tile {
    return this.createTile('reco', 'Recomendaciones', image || 'images/recomendaciones.png', '/recommendations', 'home-recommendations');
  }

  static createPlansAndServicesTile(image?: string): Tile {
    return this.createTile('planes', 'Planes y Servicios', image || 'images/planes-servicios.png', '/plans-and-services', 'home-plans-and-services');
  }

  static createMapTile(image?: string): Tile {
    return this.createTile('mapa', 'Mapa', image || 'images/mapa.png', '/map', 'home-map');
  }

  static createInfoTile(image?: string): Tile {
    return this.createTile('info', 'Info. Interés', image || 'images/info-interes.png', '/info', 'home-info');
  }

  static createAppSectionTile(index: number, label: string, image?: string): Tile {
    return this.createTile(`otros${index + 1}`, label, image || `images/otros${index + 1}.png`, `/others-${index + 1}`, `home-others-${index + 1}`);
  }

}
